<template>
    <div class="historic">
        <div class="row align-items-center historic__tit-page tit_page">
            <div class="col-12 col-lg-8">
                <h1>Histórico de investimentos</h1>
            </div>
            <div class="col-12 col-lg-4">
                    <div class="back back-hide float-md-right">
						<router-link to="/investimentos/meus-investimentos" title="Voltar"><i>&nbsp;</i> voltar</router-link>
					</div>
            </div>
        </div>
        <div class="row historic__filter">
            <div class="col-12">
               <!-- NEW STYLE -->
                <form id="formFilter" class="row">
                  <div class="tipos col-3">
                    <div class="text_label">
                        <label for="tipo">
                          <span>
                            Tipo do investimento:
                          </span>
                        </label>
                    </div>
                    <div class="inputs">
                      <at-select size="large" required placeholder="Selecione..." v-model="tipoEmprestimoFiltro">
                          <at-option v-for="(tipo, index) in tiposEmprestimos" :key="`tiposOptions${index}`" :value="tipo.value">{{tipo.name}}</at-option>
                      </at-select>
                    </div>
                  </div>
                  <div class="datas col-6">
                    <div class="text_label">
                      <label for="Datas">
                        Data do investimento:
                      </label>
                    </div>
                    <div class="inputs">
                      <datetime v-model="dataIni" class="theme-iouu" input-class="form-control" type="text" format="dd/MM/yyyy"></datetime>
                     a
                     <datetime v-model="dataFim" class="theme-iouu" input-class="form-control" type="text" format="dd/MM/yyyy"></datetime>
                    </div> 
                  </div>
                  <div class="scores col-1">
                    <div class="text_label">
                       <label for="score">
                         Score:
                       </label>
                    </div>
                    <div class="inputs">
                      <at-select size="large" required placeholder="--" v-model="scoreFiltro">
                          <at-option v-for="(score, index) in scoresArray" :key="`scoreOptions${index}`" :value="score.value">{{score.value}}</at-option>
                      </at-select>
                    </div>
                  </div>
                  <div class="btn col-2">
                    <button type="button" @click="Buscar" class="btn btn-secondary">Procurar</button>
                  </div>
                </form>
                <!-- :::::::::::::::::: -->

                <!-- OLD STYLE -->
                <!-- <form class="bg-filter filter d-flex flex-column flex-md-row justify-content-between align-items-center" style="display: none !important;">
                    <div class="filters d-flex flex-column flex-md-row  align-items-center font-weight-bold">
                        <label class="d-flex flex-column flex-md-row align-items-center ">
                            <span>Tipo do investimento:</span>
                            <select class="form-control"   @change="selecionarTipoEmprestimo">
                                <option value="">Selecione</option>
                                <option value="emprestimo-coletivo" >Empréstimo coletivo</option>
                                <option value="emprestimo-de-impacto">Empréstimo de Impacto</option>
                            </select>
                        </label>
                        <label class="d-flex flex-column flex-md-row  align-items-center ">
                            Data do investimento:
                             <input type="date" class="form-control" :value="dataIni && dataIni.toISOString().split('T')[0]" @input="dataIni = $event.target.valueAsDate">
                            a
                            <input type="date" class="form-control" :value="dataFim && dataFim.toISOString().split('T')[0]" @input="dataFim = $event.target.valueAsDate">

                        </label>
                        <label class="d-flex align-items-center ">
                            Score:
                            <select class="score form-control"  @change="selecionarScore">
                                 <option value="">--</option>
                                <option value="AA">AA</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                                <option value="E">E</option>
                                <option value="HR">HR</option>
                            </select>
                        </label>
                    </div>
                    <button type="button" @click="Buscar" class="btn btn-secondary">Procurar</button>
                </form> -->
                <!-- :::::::::::::::::::::: -->
            </div>
            <div class="col-12">
                <form class="bg-pag pagination d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <div class="font-weight-bold">
                        {{(itensPorPage*this.currentPage)+1}} - {{(itensPorPage*this.currentPage)+this.MeusInvestPG.length}} de {{this.MeusInvestimentosAll.length}} investimentos
                    </div>
                    <div class="d-flex align-items-center font-weight-bold">
                        Página <input type="number" min="1" :max="this.Paginas.length"  class="form-control" id="pgCorrente" @change="PaginaTopo($event)" :value="paginaTopo"> <span>de {{this.Paginas.length}}</span> <button type="button" class="btn btn-secondary" @click="MudarPaginaNumero()">IR</button>
                    </div>
                    <!-- <div>
                        <a @click="MudarPagina('-')">Voltar</a> | <a @click="MudarPagina('+')">Avançar</a>
                    </div> -->

                     <ul class="nav">
                        <li class="nav-item">
                            <a @click="MudarPagina('-')" :class="'nav-link back '+(VerifyCurrentPage(1)?'disabled':'')"><i></i> Voltar</a>
                        </li>
                        <li class="nav-item">
                            <a @click="MudarPagina('+')" :class="'nav-link next '+(VerifyCurrentPage(this.Paginas.length)?'disabled':'')">Avançar <i></i></a>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col" width="110">ID</th>
                                <th scope="col">Nome da Empresa</th>
                                <th scope="col">Participação @ Tx. de juros</th>
                                <!-- <th scope="col">Data da solicitação</th> -->
                                <th scope="col">Data do invest.</th>
                                <th scope="col">Data prox. repagamento</th>
                                <th scope="col">Duração</th>
                                <th scope="col" width="70">Score</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                             <tr v-for="item in this.MeusInvestPG" :class="'rating-'+lowerCase(item.SolicitacaoId.Score)">

                                <th scope="row"><router-link :to="'/investimentos/historico/historico-de-investimento/'+item._id" class="text-secondary" title="Ver detalhes do investimento">
                                    #{{ajustIdOportunidade(item.SolicitacaoId.IdOportunidade,5)}}</router-link>
                                </th>
                                <td  @click="linkReserva(item._id)">{{ ObterNome(item.SolicitacaoId)}}</td>
                                <td  @click="linkReserva(item._id)">R$ {{formatCurrency(item.Valor)}} @ {{formatCurrency(item.SolicitacaoId.RetornoBrutoAnual)}}% a.a.</td>
                               <!-- <td>{{formatData(item.SolicitacaoId.Created)}}</td> -->
                                <td  @click="linkReserva(item._id)">{{formatData(item.Created)}}</td>
                                <td  @click="linkReserva(item._id)">{{formatDataVencimento(item.DataVencimento)}}</td>
                                <td  @click="linkReserva(item._id)">{{item.SolicitacaoId.Alongamento ? item.SolicitacaoId.PrazoFinal : item.SolicitacaoId.Prazo}} meses</td>
                                <td  @click="linkReserva(item._id)" v-if="lowerCase(item.SolicitacaoId.Score) != ''" :class="'rating rating-'+lowerCase(item.SolicitacaoId.Score)"><span class="circle score"></span> {{lowerCase(item.SolicitacaoId.Score).toUpperCase()}}</td>
                                <td  @click="linkReserva(item._id)" v-if="lowerCase(item.SolicitacaoId.Score) == ''"></td>
                                <td>
                                    <!-- <router-link v-if="item.SolicitacaoId.Valor>item.SolicitacaoId.ValorCaptado && (item.SolicitacaoId.BoletosAtrasados == undefined || item.SolicitacaoId.BoletosAtrasados == 0) && item.SolicitacaoId.StatusAnalise != 'ENCERRADO'" :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-secondary">Captando</router-link>
                                    <router-link v-if="item.SolicitacaoId.Valor<=item.SolicitacaoId.ValorCaptado && (item.SolicitacaoId.BoletosAtrasados == undefined || item.SolicitacaoId.BoletosAtrasados == 0) && item.SolicitacaoId.StatusAnalise != 'ENCERRADO'" :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-success">Captado</router-link> -->
                                    <!-- Novos Status -->
                                    <!-- <router-link v-if="item.SolicitacaoId.BoletosAtrasados != undefined && item.SolicitacaoId.BoletosAtrasados != 0" :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-danger">Em Atraso</router-link>
                                    <router-link v-if="item.SolicitacaoId.StatusAnalise == 'ENCERRADO' && !item.SolicitacaoId.GerouBoletosPagamento && (item.SolicitacaoId.BoletosAtrasados == undefined || item.SolicitacaoId.BoletosAtrasados == 0) && item.AssinouCCB != true && item.SolicitacaoId.CCBsAssinaturas != true" :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-primary">Aguardando formalização</router-link>
                                    <router-link v-if="item.SolicitacaoId.StatusAnalise == 'ENCERRADO' && !item.SolicitacaoId.GerouBoletosPagamento && (item.SolicitacaoId.BoletosAtrasados == undefined || item.SolicitacaoId.BoletosAtrasados == 0) && item.AssinouCCB != true && item.SolicitacaoId.CCBsAssinaturas == true" :to="'/investimentos/minhas-ccbs/formalizar/'+item._id"  title="CCB" class="text-primary">Assinar CCB</router-link> 
                                    <router-link v-if="item.SolicitacaoId.StatusAnalise == 'ENCERRADO' && !item.SolicitacaoId.GerouBoletosPagamento && (item.SolicitacaoId.BoletosAtrasados == undefined || item.SolicitacaoId.BoletosAtrasados == 0) && item.AssinouCCB == true && item.SolicitacaoId.CCBsAssinaturas == true " :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-primary">Processando Desembolso</router-link>  -->
                                    <router-link v-if="new Date(item.DataVencimento) < new Date() " :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-success">Em atraso</router-link>
                                    <router-link v-else-if="new Date(item.DataVencimento) >= new Date() " :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-success">Ativo</router-link>
                                    <router-link v-else-if="item.Status == 1" :to="'/investimentos/historico/historico-de-investimento/'+item._id"  title="Ver detalhes do investimento" class="text-success">Encerrado</router-link>
                               </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination
                    :paginasTotais="this.PaginasTotais"
                    :paginaAtual="this.currentPage+1"
                    :navigate="(route)=>{route == null ? '' : this.currentPage = route-1}"
                />
            </div>
        </div>
    </div>
</template>


<script>
  /* eslint-disable */

  import ApiClient from '../utils/api-client'
  import BarChart from '@/components/charts/BarChartInvestimentos'
  import Pagination from '@/components/Pagination'
  import * as mutationTypes from "@/store/mutation-types.js";


  export default {
    components: { BarChart, Pagination },
    data() {
            return {
                MeusInvestimentosAll:[],
                currentPage:0,
                itensPorPage:10,
                paginaTopo:1,
                scoreFiltro:"",
                tipoEmprestimoFiltro:"",
                dataIni:null,
                dataFim:null,
                tiposEmprestimos: [
                  {value: "emprestimo-coletivo", name: "Empréstimo Coletivo"},
                  {value: "emprestimo-social", name: "Empréstimo Social"}
                ],
                scoresArray: [
                  {value: "AA"},
                  {value: "A"},
                  {value: "B"},
                  {value: "C"},
                  {value: "D"},
                  {value: "E"},
                  {value: "HR"}
                ]
            }
        },
    methods: {

        linkReserva(id){
            window.location.href='/#/investimentos/historico/historico-de-investimento/'+id;
        },
        ObterNome(solicitacao){


            if(solicitacao.Empresa != null && solicitacao.Empresa.NomeFantasia != "")
                    return solicitacao.Empresa.NomeFantasia;

            if(solicitacao.Impacto != null && solicitacao.Impacto.NomeFantasia != "")
                    return solicitacao.Impact.NomeFantasia;

            if(solicitacao.Social != null && solicitacao.Social.RazaoSocial != "")
                    return solicitacao.Social.RazaoSocial;
            
             if(solicitacao.Social != null && solicitacao.Social.NomeCompleto != "")
                    return solicitacao.Social.NomeCompleto;

        },

        Buscar(){

            this.$store.commit(mutationTypes.START_LOADING);
            ApiClient.getInfosMyInvestments()
            .then(infos => {
                    var total = 0 ;
                    var Investimentos = infos.data;
                    this.currentPage = 0;

                      Investimentos = Investimentos.filter((item)=>{ return !(item.SolicitacaoId.StatusAnalise == "ENCERRADO" && item.Status == 2)});


                    if(this.tipoEmprestimoFiltro != ""){
                        Investimentos = Investimentos.filter((item)=>{ return item.SolicitacaoId.TipoEmprestimo == this.tipoEmprestimoFiltro});
                    }

                    if(this.dataIni != null && this.dataIni != undefined && this.dataIni != ""){
                        Investimentos = Investimentos.filter((item)=>{
                            var create = new Date(item.Created.split('T')[0])
                            create.setHours(create.getHours()+3);

                            var filtroInicio = new Date(this.dataIni.split('T')[0])
                            filtroInicio.setHours(filtroInicio.getHours()+3);
                            filtroInicio.setHours(0);
                            return create >= filtroInicio});
                    }

                    if(this.dataFim != null && this.dataFim != undefined && this.dataFim != ""){
                        Investimentos = Investimentos.filter((item)=>{

                            var create = new Date(item.Created.split('T')[0])
                            create.setHours(create.getHours()+3);
                            var filtroFim = new Date(this.dataFim.split('T')[0])
                            filtroFim.setHours(filtroFim.getHours()+3);
                            filtroFim.setHours(23);
                            filtroFim.setMinutes(59);

                            return create <= filtroFim});
                    }

                    if(this.scoreFiltro != ""){

                        if(this.scoreFiltro == "AA" || this.scoreFiltro=="HR"){
                            Investimentos = Investimentos.filter((item)=>{ return item.SolicitacaoId.Score == this.scoreFiltro});
                        }
                        else{
                            Investimentos = Investimentos.filter((item)=>{ return (item.SolicitacaoId.Score || "" ).length>0 ? item.SolicitacaoId.Score[0]  == this.scoreFiltro : false;});
                        }
                    }

                this.MeusInvestimentosAll=Investimentos;
                this.paginaTopo = 1;
                this.$store.commit(mutationTypes.STOP_LOADING)

            }).catch(error => {
            console.log('error', error)

            this.$store.commit(mutationTypes.STOP_LOADING)
            })

        },
        VerifyCurrentPage(page){
            return page == this.currentPage+1;
        },
          Link(page){
            return  this.currentPage = page-1;
        },

        MudarPagina(acao){

            if(acao == "-"){

                if(this.currentPage-1 >= 0){
                this.currentPage = this.currentPage-1;
                this.paginaTopo = this.currentPage+1;
                }

            }
            if(acao == "+"){
                if(this.currentPage+1 < this.Paginas.length){
                    this.currentPage = this.currentPage+1;
                    this.paginaTopo = this.currentPage+1;
                }
            }
        },

        MudarPaginaNumero(){

            console.log(this.paginaTopo,this.paginaTopo-1,this.Paginas.length)
            if(this.paginaTopo-1 > this.Paginas.length-1)
            {
                this.currentPage =this.Paginas.length -1;
                this.paginaTopo = this.Paginas.length;
                return;
            }

            if(this.paginaTopo-1 < 0)
            {
                this.currentPage =0;
                this.paginaTopo = 1;
                return;
            }

              this.currentPage = this.paginaTopo-1;
        },

        PaginaTopo(event){

            this.paginaTopo = parseInt(event.target.value);
        },

        selecionarTipoEmprestimo(data) {
          this.tipoEmprestimoFiltro = data.target.value;
        },
         selecionarScore(data) {
          this.scoreFiltro = data.target.value;
        },

     formatCurrency(value) {
        if(value != null)
          return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

        return 0;
      },
      ajustIdOportunidade(id, qtd) {
				var s = String(id);

				while (s.length < (qtd || 2)) {
					s = "0" + s;
				}

				return s;
            },
        formatData(data){
            var date = new Date(data);
            return date.toLocaleDateString()
        },
        formatDataVencimento(data){
            if(typeof data != "undefined" && data != "-"){
                let date = new Date(data);
                let day = date.getDate() + 1
                let month = date.getMonth() + 1
                month >= 10 ? '' : month = "0"+month
                day >= 10 ? '' : day = "0"+day
                return day + "/" + month + "/" + date.getFullYear()
            }
            return "-"
        },
        lowerCase(texto) {
            if (texto == null || texto == undefined) return "";

            if (texto == "AA" || texto == "HR") return texto.toLowerCase();

            return texto.substr(0,1).toLowerCase();
        },
        dataSort(arr){
            let swapped;
            do {
            	swapped = false;
            	for (let i=0; i < arr.length-1; i++) {
            		if (arr[i].Created < arr[i+1].Created) {
            			let temp = arr[i];
            			arr[i] = arr[i+1];
            			arr[i+1] = temp;
            			swapped = true;
            		}
            	}
            } while (swapped);
            return arr
        },
        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/historico/',
                title: 'Histórico',
            })
        },
    },
    computed: {
      User: function() {return this.$store.state.currentUser;},
      CurrentPage(){ return this.currentPage;},

      MeusInvestPG(){ return this.MeusInvestimentosAll.slice(this.CurrentPage*this.itensPorPage, (this.CurrentPage*this.itensPorPage)+this.itensPorPage);},

      Paginas(){
                var pgs = Math.ceil((this.MeusInvestimentosAll.length/this.itensPorPage));

                var paginas = new Array();
                for(var i = 0 ; i < pgs ; i++)
                    paginas.push(i+1)

                return paginas;
          },
        PaginasTotais(){
            return Math.ceil((this.MeusInvestimentosAll.length/this.itensPorPage));
        }
    },
    async created() {
        this.$store.commit(mutationTypes.START_LOADING);
        ApiClient.getInfosMyInvestments()
        .then(infos => {
            let resposta = infos.data
            var total = 0
            this.dataSort(resposta)
            resposta = resposta.filter((item) => {
                return !(item.SolicitacaoId != null && item.SolicitacaoId.StatusAnalise == "ENCERRADO" && item.Status == 2)
            });
            
            this.MeusInvestimentosAll = resposta;
            this.currentPage = 0;

            this.$store.commit(mutationTypes.STOP_LOADING)
        }).catch(error => {
            console.log('error', error)

            this.$store.commit(mutationTypes.STOP_LOADING)
        })
        //tagueamento GA
        await this.taggingGA();
    }

}
</script>

<style lang="scss" scoped>
	@import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";


    #formFilter {
      &{
        width: 100%;
        padding: 15px;
        margin: 0;
        background-color: #eee;
        color: #666;
        border-radius: 5px;
        margin-bottom: 1rem;
      }

      .tipos {
        @include mob {
          flex: 0 0 100%;
          max-width: 100%;
          text-align: center;
        }
      }

      .datas {
        @include brkp-01(1050px) {
          flex: 0 0 58.3333333333%;
          max-width: 58.3333333333%;
        }

        @include mob {
          flex: 0 0 100%;
          max-width: 100%;
          text-align: center;
          margin-top: 1rem;
        }
      }

      .scores {
        @include brkp-01(1050px) {
          flex: 0 0 16.6666666667%;
          max-width: 16.6666666667%;
        }

        @include mob {
          flex: 0 0 100%;
          max-width: 100%;
          text-align: center;
          margin-top: 1rem;
        }
      }


      .datas {
        .vdatetime {
          width: 48%;
          display: inline-block;
          vertical-align: middle;

          @include xs {
            width: 100%;
          }
        }

        @include mob {
          flex: 0 0 100%;
          max-width: 100%;
          text-align: center;
        }
      }

      .btn {
        &{
          text-align: right;

          @include brkp-01(1050px) {
            flex: 0 0 100%;
            max-width: 100%;
            text-align: center;
          }
        }
        button {
          display: inline-block;
          font-size: .8rem;
          vertical-align: middle;
          margin-top: 25px;

          @include brkp-01(1440px) {
            margin-top: 18px;
          }

          @include brkp-01(1200px) {
            font-size: 0.7rem;
          }

          @include xs {
            margin: 0 !important;
          }
        }
      }

    }

    .table-hover {
        tbody {
            tr {
                &:hover {
                    background: #f7f7f7;
                }
            }
        }
    }
    table {
        thead {
            th {
                border-top: none;
            }
        }

        tr {
            border-bottom: none;
        }

        th, td {
            text-align: center;
        }

        th {
            a {
                text-decoration: underline!important;
            }
        }

        .rating {
            color: #999;
            font-weight: bold;

            .score {
                display: inline-block;
                position: relative;
                border-radius: 50%;
                text-transform: uppercase;
                top: 2px;
                width: 15px;
                height: 15px;
            }
        }

        // DESKTOP
        @include ds {
            thead {
                th {
                    @include font-size(12px);
                }
            }
            th, td {
                @include font-size(12px);
                a {
                    @include font-size(12px);
                }
            }

            .rating {
                .score {
                    width: 12px;
                    height: 12px;
                }
            }
        }
    }

    .historic {
        &__tit-page {
            margin-bottom: 30px;

            // DESKTOP
            @include ds {
                margin-bottom: 15px;
                h1 {
                    @include font-size(25px);
                }
            }
        }

        &__filter {
            .bg-filter, .bg-pag {
                border-radius: 5px;
            }

            .bg-filter {
                margin-bottom: 25px;
                padding: 25px 20px;
                background: #eee;
            }

            .bg-pag {
                padding: 20px;
                background: #f6f6f6;
            }

            // DESKTOP
            @include ds {
                @include font-size(12px);
                .bg-filter {
                    padding: 15px;
                    margin-bottom: 15px;
                }
                .bg-pag {
                    padding: 15px;
                }
            }
        }

        &__pagination {
            display: flex;
            justify-content: center;

            a {
                color: #666;
            }

            .page-item.active {
                .page-link {
                    background: $c3;
                    border-color: $c3;
                }
            }

            // DESKTOP
            @include ds {
                @include font-size(12px);
            }
        }
        .nav {
            li {
                position: relative;

                &:first-child {
                    border-right: 1px solid #ccc;
                }
            }
            a {
                font-weight: bold;
                color: #999999;
                @include font-size(15px);

                i {
                   background: url(/static/assets/images/icon-arrow.svg) no-repeat;
                   background-size: auto;
                   width: 13px;
                   height: 13px;
                   display: block;
                   position: relative;
                   top: 5px;
                }

                &:hover {
                    color: $c3;
                }

                &.back {
                    i {
                        margin-right: 10px;
                        float:left;
                        transform: rotate(180deg);
                    }

                    &.disabled {
                    color: #ccc;
                    i {
                        margin-right: 5px;
                        background: url(/static/assets/images/icon-arrow-back.svg) no-repeat;
                        transform: rotate(0deg);
                    }
                    }
                }

                &.next {
                    i {
                        margin-left: 10px;
                        float:right;
                    }

                    &.disabled {
                        color: #ccc;
                        i {
                            margin-right: 5px;
                            background: url(/static/assets/images/icon-arrow.svg) no-repeat;
                            transform: rotate(0deg);
                        }
                     }
                }


            }
        }

        .filter {
             color: #666;
            button {
                padding-left: 20px;
                padding-right: 20px;
            }
        }

        .filters {
            label {
                padding:0px;
                margin:0 15px 0 0;

                span {
                    width: 100%;
                }
            }

            input {
                width: 180px;
                margin: 0 10px;
            }

            // MOBILE
            @include xs {
                width: 100%;
                text-align: center;
                label {
                    @include font-size(12px);
                    margin:0 0 15px;
                    width: 100%;
                }
                input,
                textarea {
                    width: 100%;
                    @include font-size(12px);
                }
                select {
                    margin-right:0px;
                    @include font-size(12px);
                }
            }

            // DESKTOP
            @include ds {
                input,
                textarea {
                    @include font-size(11px);
                }
                select {
                    @include font-size(11px);
                }
            }
        }

        .pagination {
            color: #666;

            input {
                width: 60px;
                margin: 0 10px;
                text-align: center;
            }

            // MOBILE
            @include xs {
                .font-weight-bold {
                    margin-bottom: 10px;
                }
                span {
                    display: block;
                }
                button {
                    width: 50px;
                }
            }
        }

        form {
            input {
                color: #999;
                margin:0px;
            }
            select {
                &.score {
                    margin: 0 0 0 10px;
                }
            }
            button {
                text-transform: uppercase;
                padding-left: 15px;
                padding-right: 15px;
                font-weight: bold;
                margin: 0 10px;
            }

            // MOBILE
            @include xs {
                display: flex;
                flex-direction: row;
                @include font-size(12px);
                input {
                    @include font-size(12px);
                }
                button {
                    @include font-size(12px);
                    display: block;
                    width: 100%;
                }
            }

            // DESKTOP
            @include ds {
                button {
                    @include font-size(12px);
                }
            }
        }
    }

    .tit_page {
        h1 {
            @include xs {
            font-size: calcRem(25);
         }
    }

    // BOTÃO VOLTAR
    .back a {
        @include ds {
            @include font-size(12px);

            i {
                width: 6px;
                margin-right: 9px;
            }
        }
    }

    .float-right {
        padding-top: 1rem;
    }
}

table {
  border: none !important;
  th,
  td {
    text-align: center;

    // MEDIA max: 1199px
    @include brkp-01(1199px) {
      font-size: calcRem(12);
    }

    &:nth-child(1) {
      @include brkp-01(991px) {
        width: 40px;
      }
    }

    &:nth-child(2) {

    }

    &:nth-child(3) {
      // MEDIA max: 1199px
      @include brkp-01(1199px) {
        display: none;
      }
    }

    &:nth-child(4) {
      @include brkp-01(991px) {
        width: 140px;
      }
      @include sm {
        display: none;
      }

      @include xs {
        display: none;
      }
    }

    &:nth-child(5) {
      @include brkp-01(991px) {
        width: 80px;
      }

      @include sm {
        display: none;
      }

      @include xs {
        display: none;
      }
    }

    &:nth-child(6) {
      // MEDIA max: 1199px
      @include brkp-01(1199px) {
        width: 135px;
      }

      @include sm {
        display: none;
      }

      @include xs {
        display: none;
      }
    }

    &:nth-child(7) {
      @include brkp-01(991px) {
        display: none;
      }
    }
  }



  th {
    border-top: none;
  }

  tr {
    border-bottom: 1px solid #e9ecef !important;
  }

  td {
    color: #666;
  }

  p {
    margin: 0px;
    padding: 0px;
    &.small {
      color: #888;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      padding-top: 5px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/ListHistoric.vue